import { render, staticRenderFns } from "./AdminPermissionsView.vue?vue&type=template&id=1061ff0a&scoped=true"
import script from "./AdminPermissionsView.vue?vue&type=script&lang=js"
export * from "./AdminPermissionsView.vue?vue&type=script&lang=js"
import style0 from "./AdminPermissionsView.vue?vue&type=style&index=0&id=1061ff0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061ff0a",
  null
  
)

export default component.exports